/**
 * SEO Cache Manager Service
 *
 * Manages cache invalidation for SEO-related caches.
 * Should be called when configuration changes (e.g., customer name, base URL).
 */

import { Injectable } from '@angular/core';
import { clearSchemaCache, getSchemaCacheSize } from './schema-generators';

@Injectable({
  providedIn: 'root',
})
export class SeoCacheManagerService {
  /**
   * Clears all SEO-related caches
   * Call this when:
   * - Customer configuration changes
   * - Base URL changes
   * - Logo URL changes
   * - Any other SEO-impacting configuration changes
   */
  clearAllCaches(): void {
    clearSchemaCache();
    console.log('[SEO Cache] All caches cleared');
  }

  /**
   * Gets cache statistics for monitoring
   */
  getCacheStats(): {
    schemaCache: number;
  } {
    return {
      schemaCache: getSchemaCacheSize(),
    };
  }

  /**
   * Logs cache statistics to console
   * Useful for debugging and monitoring
   */
  logCacheStats(): void {
    const stats = this.getCacheStats();
    console.log('[SEO Cache Stats]', {
      'Schema Cache Size': stats.schemaCache,
    });
  }
}
